import React, { useState, useEffect } from 'react';
import { FiPackage, FiPlus, FiEdit2, FiFileText, FiSearch, FiFilter, FiDownload, FiTrendingUp, FiPercent } from 'react-icons/fi';
import { TbCurrencyRupee } from 'react-icons/tb';
import { toast } from 'react-hot-toast';
import api from '../../utils/api';
import html2pdf from 'html2pdf.js';

const SuperAdminBanquetManagement = () => {
  const [banquets, setBanquets] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingBanquet, setEditingBanquet] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedVendor, setSelectedVendor] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [stats, setStats] = useState({
    totalBanquets: 0,
    totalPackages: 0,
    avgPricePerPack: 0,
    totalRevenue: 0,
    avgGstPercentage: 0
  });

  // Form data
  const [formData, setFormData] = useState({
    noOfPacks: '',
    pricePerPack: '',
    gstPercentage: '',
    discount: '',
    discountType: 'percentage'
  });

  // Fetch banquets
  const fetchBanquets = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: currentPage,
        limit: 10
      });

      if (searchTerm) params.append('search', searchTerm);
      if (selectedVendor) params.append('vendorId', selectedVendor);

      const response = await api.get(`/superadmin/banquets?${params}`);
      
      if (response.data.success) {
        setBanquets(response.data.data);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.error('Error fetching banquets:', error);
      toast.error('Failed to fetch banquets');
    } finally {
      setLoading(false);
    }
  };

  // Fetch vendors for filter dropdown
  const fetchVendors = async () => {
    try {
      const response = await api.get('/superadmin/banquets/vendors');
      if (response.data.success) {
        setVendors(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching vendors:', error);
      toast.error('Failed to fetch vendors');
    }
  };

  // Fetch stats
  const fetchStats = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedVendor) params.append('vendorId', selectedVendor);

      const response = await api.get(`/superadmin/banquets/stats?${params}`);
      
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
      toast.error('Failed to fetch stats');
    }
  };

  // Handle download bill
const handleDownloadBill = async (banquet) => {
  try {

    const vendor = banquet.vendorId

    console.log(vendor)

    const billHTML = `
      <div style="font-family: Courier New, monospace; width:80mm; padding:5mm; font-size:11px; line-height:1.4">

        <div style="text-align:center;margin-bottom:10px">
          <h2 style="font-size:18px;font-weight:bold">
            ${vendor.restaurantDetails?.restaurantName || "HUKAM MERE AAKA"}
          </h2>

          <div style="font-size:10px">
            ${banquet.banquetName || ""}
          </div>

          <div style="font-size:10px">
            ${vendor.restaurantDetails?.address || ""}
          </div>

          <div style="font-size:9px;color:#555">
            ${vendor.restaurantDetails?.gstNumber ? `GST: ${vendor.restaurantDetails.gstNumber}` : ""}
            ${vendor.restaurantDetails?.fssaiNumber ? ` | FSSAI: ${vendor.restaurantDetails.fssaiNumber}` : ""}
          </div>
        </div>

        <div style="border-bottom:1px dashed #000;padding-bottom:8px;margin-bottom:8px;font-size:10px">
          <div style="display:flex;justify-content:space-between">
            <span><b>Bill #</b></span>
            <span>${banquet.billNo}</span>
          </div>

          <div style="display:flex;justify-content:space-between">
            <span><b>Date</b></span>
            <span>
              ${new Date(banquet.createdAt).toLocaleString("en-IN")}
            </span>
          </div>

          ${
            vendor.personalDetails?.contactNumber
              ? `<div style="display:flex;justify-content:space-between">
                  <span><b>Phone</b></span>
                  <span>${vendor.personalDetails.contactNumber}</span>
                </div>`
              : ""
          }
        </div>

        <table style="width:100%;border-collapse:collapse;font-size:10px">

          <thead>
            <tr style="border-bottom:2px solid black">
              <th align="left">ITEM</th>
              <th align="right">QTY</th>
              <th align="right">PRICE</th>
              <th align="right">TOTAL</th>
            </tr>
          </thead>

          <tbody>

            <tr style="border-bottom:1px dashed #ccc">
              <td>Banquet Package #${banquet.noOfPacks}</td>
              <td align="right">${banquet.noOfPacks}</td>
              <td align="right">₹${banquet.pricePerPack}</td>
              <td align="right">₹${banquet.subtotal}</td>
            </tr>

          </tbody>
        </table>

        <div style="margin-top:10px;border-top:2px solid #000;padding-top:8px;font-size:11px">

          <div style="display:flex;justify-content:space-between">
            <span>Subtotal</span>
            <span>₹${Number(banquet.subtotal).toFixed(2)}</span>
          </div>

          ${
            banquet.discountAmount > 0
              ? `<div style="display:flex;justify-content:space-between;color:#16a34a">
                  <span>Discount</span>
                  <span>- ₹${Number(banquet.discountAmount).toFixed(2)}</span>
                </div>`
              : ""
          }

          <div style="display:flex;justify-content:space-between">
            <span>CGST</span>
            <span>₹${(Number(banquet.gstAmount) / 2).toFixed(2)}</span>
          </div>

          <div style="display:flex;justify-content:space-between">
            <span>SGST</span>
            <span>₹${(Number(banquet.gstAmount) / 2).toFixed(2)}</span>
          </div>

          <div style="display:flex;justify-content:space-between;font-weight:bold;border-top:2px solid #000;margin-top:6px;padding-top:6px;font-size:13px">
            <span>GRAND TOTAL</span>
            <span>₹${Number(banquet.total).toFixed(2)}</span>
          </div>

        </div>

        <div style="text-align:center;margin-top:15px;font-size:10px;border-top:1px dashed #000;padding-top:8px">
          <p>Thank you for your business!</p>
          ${
            vendor.personalDetails?.contactNumber
              ? `<p>Contact: ${vendor.personalDetails.contactNumber}</p>`
              : ""
          }
          <p>Generated ${new Date().toLocaleString("en-IN")}</p>
        </div>

      </div>
    `;

    const element = document.createElement("div");
    element.innerHTML = billHTML;
    document.body.appendChild(element);

    const opt = {
      margin: 0,
      filename: `${banquet.billNo}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 3 },
      jsPDF: {
        unit: "mm",
        format: [80, 200],
        orientation: "portrait",
      },
    };

    await html2pdf().set(opt).from(element).save();

    document.body.removeChild(element);

    toast.success("Bill downloaded successfully!");

  } catch (error) {
    console.error(error);
    toast.error("Failed to generate bill");
  }
};

const handleExport = () => {
  try {
    // Create CSV content
    const headers = ['Bill No', 'Banquet Name', 'Package #', 'Price/Pack', 'Subtotal', 'Discount Type', 'Discount', 'Discount Amount', 'GST %', 'GST Amount', 'Total', 'Created Date'];
    const csvContent = [
      headers.join(','),
      ...banquets.map(banquet => [
        banquet.billNo,
        banquet.banquetName || 'N/A',
        banquet.noOfPacks,
        banquet.pricePerPack,
        banquet.subtotal,
        banquet.discountType,
        banquet.discount,
        banquet.discountAmount || 0,
        banquet.gstPercentage,
        banquet.gstAmount,
        banquet.total,
        new Date(banquet.createdAt).toLocaleDateString('en-IN')
      ].join(','))
    ].join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `banquet_bills_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success('Data exported successfully!');
  } catch (error) {
    console.error('Export error:', error);
    toast.error('Failed to export data');
  }
};

  // Effects
  useEffect(() => {
    fetchBanquets();
    fetchVendors();
    fetchStats();
  }, [currentPage, searchTerm, selectedVendor]);

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Banquet Management</h1>
        <p className="text-gray-600">Manage all banquet bookings across all vendors</p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total Packages</p>
              <p className="text-2xl font-bold text-gray-900">{stats.totalPackages}</p>
            </div>
            <FiPackage className="text-3xl text-green-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Avg Price/Pack</p>
              <p className="text-2xl font-bold text-gray-900">₹{stats.avgPricePerPack}</p>
            </div>
            <FiPackage className="text-3xl text-blue-500" />
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total Revenue</p>
              <p className="text-2xl font-bold text-gray-900">₹{stats.totalRevenue}</p>
            </div>
            <TbCurrencyRupee className="text-3xl text-purple-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Avg GST %</p>
              <p className="text-2xl font-bold text-gray-900">{stats.avgGstPercentage}%</p>
            </div>
            <FiPercent className="text-3xl text-orange-500" />
          </div>
        </div>
      </div>

      {/* Filters and Actions */}
      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="flex flex-col md:flex-row gap-4 flex-1">
            <div className="relative flex-1">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search by bill number..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <div className="relative">
              <FiFilter className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

              <select
                value={selectedVendor}
                onChange={(e) => setSelectedVendor(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white"
              >
                <option value="">All Vendors</option>

                {vendors.map((vendor) => (
                  <option key={vendor._id} value={vendor._id}>
                    {vendor.restaurantDetails?.restaurantName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleExport}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              <FiDownload /> Export
            </button>
          </div>
        </div>
      </div>

      {/* Banquets Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <span className="font-bold">#</span>
                    Bill No
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                 <div className="flex items-center gap-2">
                    <span className="font-bold">📋</span>
                    Banquet Name
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiPackage />
                    Package
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <span className="font-bold">₹</span>
                    Price/Pack
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Subtotal
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiPercent />
                    Discount
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  GST
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiTrendingUp />
                    Total
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="9" className="px-6 py-12 text-center">
                    <div className="text-gray-500">Loading...</div>
                  </td>
                </tr>
              ) : banquets.length === 0 ? (
                <tr>
                  <td colSpan="9" className="px-6 py-12 text-center">
                    <div className="text-gray-500">
                      <FiPackage className="mx-auto text-4xl text-gray-300 mb-4" />
                      <h3 className="text-lg font-medium text-gray-900 mb-2">No banquets found</h3>
                      <p className="text-gray-500">No banquet bookings available</p>
                    </div>
                  </td>
                </tr>
              ) : (
                banquets.map((banquet) => (
                  <tr key={banquet._id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10 flex items-center justify-center bg-blue-100 rounded-full">
                          <span className="text-blue-600 font-semibold text-sm">#</span>
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">{banquet.billNo}</div>
                          <div className="text-xs text-gray-500">Bill Number</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10 flex items-center justify-center bg-green-100 rounded-full">
                            <span className="text-green-600 font-semibold text-sm">📋</span>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">{banquet.banquetName || 'N/A'}</div>
                            <div className="text-xs text-gray-500">Banquet Name</div>
                          </div>
                        </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10 flex items-center justify-center bg-blue-100 rounded-full">
                          <span className="text-blue-600 font-semibold text-sm">{banquet.noOfPacks}</span>
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">Package #{banquet.noOfPacks}</div>
                          <div className="text-xs text-gray-500">No. of packs</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">₹{banquet.pricePerPack}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">₹{banquet.subtotal}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-green-600">
                          -₹{banquet.discountAmount || 0}
                        </span>
                        <span className="text-xs text-gray-500">
                          ({banquet.discountType === 'percentage' ? `${banquet.discount}%` : 'Fixed'})
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{banquet.gstPercentage}%</div>
                      <div className="text-xs text-gray-500">₹{banquet.gstAmount}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-lg font-bold text-blue-600">₹{banquet.total}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex gap-2">
                        {/* Download Bill */}
                        <button
                          onClick={() => handleDownloadBill(banquet)}
                          className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-green-700 bg-green-50 hover:bg-green-100 rounded-lg transition"
                        >
                          <FiFileText size={14} />
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {pagination.pages > 1 && (
          <div className="px-6 py-4 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-700">
                Showing {((pagination.page - 1) * pagination.limit) + 1} to {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={pagination.page === 1}
                  className="px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Previous
                </button>
                <span className="px-3 py-1 text-sm text-gray-700">
                  Page {pagination.page} of {pagination.pages}
                </span>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, pagination.pages))}
                  disabled={pagination.page === pagination.pages}
                  className="px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SuperAdminBanquetManagement;
